import(/* webpackMode: "eager" */ "/home/interim/frontend/app/reviews/page.tsx");
